// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.shared.eyefinity.EyefinityListItemRequest */
/* istanbul ignore next */
@GandalfModel
export class EyefinityListItemRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.EyefinityListCategoryType)
	@GandalfLabel('Category Type')
	@GandalfValidator({ notNull: { message: 'Category Type is required' } })
	@GandalfProperty({ designType: constants.EyefinityListCategoryType, isRequired: true })
	categoryType!: constants.EyefinityListCategoryType;

}
